import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import Modal from "../../Modal";
import Icon from "../../Icon";
import styles from "./NewMessageModal.module.sass";

// Updated: User selection UX - handle as primary, first name as secondary
const NewMessageModal = ({ visible, onClose, onSearch, onSelect, results = [] }) => {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const performSearch = useCallback(async (q) => {
    if (!onSearch) return;
    setLoading(true);
    try {
      await onSearch(q);
    } finally {
      setLoading(false);
    }
  }, [onSearch]);

  useEffect(() => {
    if (!visible) return;
    performSearch("");
  }, [visible, performSearch]);

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => {
      performSearch(query);
    }, 300);
    return () => clearTimeout(timer);
  }, [query, visible, performSearch]);

  return (
    <Modal visible={visible} onClose={onClose} outerClassName={styles.outerWide}>
      <div className={styles.modal}>
        <h2 className={styles.title}>New message</h2>

        <div className={styles.searchRow}>
          <div className={styles.searchBox}>
            <Icon name="search" size="18" />
            <input
              type="text"
              autoFocus
              placeholder="Search creators and hosts..."
              value={query}
              onChange={(e) => {
                const v = e.target.value;
                setQuery(v);
              }}
            />
          </div>
        </div>

        <div className={styles.results}>
          {loading && (
            <div className={styles.loading}>Searching…</div>
          )}
          {!loading && results.length === 0 && (
            <div className={styles.empty}>No users found</div>
          )}
          {!loading && results.map((u) => {
            const handle = u.handle || u.username ? `@${(u.handle || u.username).replace(/^@/, '')}` : null;
            const firstName = u.first_name || (u.name ? u.name.split(' ')[0] : '');

            return (
              <button key={u.id} className={styles.userRow} onClick={() => onSelect && onSelect(u)}>
                <img src={u.image || "/images/content/avatar-1.jpg"} alt={u.name} />
                <div className={styles.meta}>
                  <div className={styles.name}>
                    {handle ? (
                      <>
                        <span style={{ color: '#0f084b' }}>{handle}</span>
                        <span style={{ marginLeft: '8px', opacity: 0.7, fontWeight: '400', fontSize: '14px', color: '#666' }}>{firstName}</span>
                      </>
                    ) : (
                      u.name
                    )}
                  </div>
                  {u.role && <div className={styles.role}>{u.role}</div>}
                </div>
                <Icon name="arrow-right" size="16" />
              </button>
            );
          })}
        </div>

        <div className={styles.actions}>
          <button className={cn("button-stroke", styles.cancelBtn)} onClick={onClose}>Cancel</button>
        </div>
      </div>
    </Modal>
  );
};

export default NewMessageModal;


